import { render, staticRenderFns } from "./CustomMultiSelect.vue?vue&type=template&id=a4607636&"
import script from "./CustomMultiSelect.vue?vue&type=script&lang=js&"
export * from "./CustomMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports